module.exports = ".header-icon {\n  padding: 0 14px; }\n\n.header-spacer {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto; }\n\n.header {\n  position: fixed;\n  top: 0;\n  z-index: 1000; }\n\n.message-text {\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/header/header.component.scss
// module id = ./src/app/components/framework/header/header.component.scss
// module chunks = main